import { RateSchedule } from 'src/app/shared/models/gql/rate.model';

export const DEFAULT_RATE_SCHEDULE: RateSchedule = {
  weekday: false,
  saturday: false,
  sunday: false,
  publicHoliday: false,
  daytime: false,
  evening: false,
  overnight: false,
} as const;
